import {selectSessionUserId} from 'stores/selectors/sessionSelectors';
import {SignalREvent, SignalRHub} from '../constants/dataEnum';
import {invokeAPI} from '../stores/business/commonBusiness';
import GlobalReduxStore from '../stores/globalReduxStore';

export const shareUnshareProtocolAndFolderApi = async (
  sharedProtocolIds,
  unsharedProtocolIds,
  sharedFolderIds,
  unsharedFolderIds,
  userId,
  targetUserIds,
  unshareTargetUserIds,
) => {
  let response;
  const {dispatch} = GlobalReduxStore.getStore();
  try {
    response = await dispatch(
      invokeAPI(
        SignalRHub.PROTOCOL_MANAGEMENT,
        SignalREvent.SHARE_UNSHARE_PROTOCOLS_AND_FOLDERS,
        sharedProtocolIds,
        unsharedProtocolIds,
        sharedFolderIds,
        unsharedFolderIds,
        userId,
        targetUserIds,
        unshareTargetUserIds,
      ),
    );
  } catch (error) {
    console.error('error in shareUnshareProtocolAndFolderApi', error);
  }
  return response;
};

export const getProtocolByIdAndUserId = async (protocolId, userId) => {
  let response;
  const {dispatch} = GlobalReduxStore.getStore();
  try {
    response = await dispatch(
      invokeAPI(SignalRHub.PROTOCOL_MANAGEMENT, SignalREvent.GET_PROTOCOL_BY_ID_AND_USER_ID, protocolId, userId, false),
    );
  } catch (error) {
    console.error('error in shareUnshareProtocolAndFolderApi', error);
  }
  return response;
};
export const getRunningProtocol = async () => {
  const store = GlobalReduxStore.getStore();
  let response;

  try {
    response = await store.dispatch(invokeAPI(SignalRHub.STATE, SignalREvent.GET_RUNNING_PROTOCOL));
  } catch (err) {
    console.error('error on calling getRunningProtocol API', err);
  }

  return response;
};

export const clearRunningProtocol = async () => {
  const store = GlobalReduxStore.getStore();
  let response;

  try {
    response = await store.dispatch(invokeAPI(SignalRHub.STATE, SignalREvent.CLEAR_RUNNING_PROTOCOL));
  } catch (err) {
    console.error('error on calling clearRunningProtocol API', err);
  }

  return response;
};

export const fetchProtocolById = async (id) => {
  const store = GlobalReduxStore.getStore();
  let response;

  try {
    response = await store.dispatch(
      invokeAPI(SignalRHub.PROTOCOL_MANAGEMENT, SignalREvent.GET_PROTOCOL_BY_ID, id, false),
    );
  } catch (err) {
    console.error('error on calling fetchProtocolById API', err);
  }

  return response.payload;
};

export const sendProtcolsAndFolder = async (protocolIds, folderIds, userId, targetUserIds) => {
  const store = GlobalReduxStore.getStore();
  let response;

  try {
    response = await store.dispatch(
      invokeAPI(
        SignalRHub.PROTOCOL_MANAGEMENT,
        SignalREvent.SEND_PROTOCOLS_AND_FOLDERS,
        protocolIds,
        folderIds,
        userId,
        targetUserIds,
      ),
    );
  } catch (err) {
    console.error('error on calling sendProtcolsAndFolder API', err);
  }

  return response;
};

export const isFolderContainsTessaraProtocolApi = async (folderIds, userId) => {
  const store = GlobalReduxStore.getStore();
  let response;

  try {
    response = await store.dispatch(
      invokeAPI(SignalRHub.PROTOCOL_MANAGEMENT, SignalREvent.IS_FOLDER_CONTAINS_TESSARA_PROTOCOL, folderIds, userId),
    );
  } catch (err) {
    console.error('error on calling isFolderContainsTessaraProtocolApi API', err);
  }

  return response;
};

export const getFolderDetailsById = async (folderId) => {
  const store = GlobalReduxStore.getStore();
  let response;

  try {
    response = await store.dispatch(
      invokeAPI(SignalRHub.PROTOCOL_MANAGEMENT, SignalREvent.GET_PROTOCOL_FOLDER_DATA_BY_ID, folderId, false),
    );
  } catch (err) {
    console.error('error on calling getFolderDetailsById API', err);
  }

  return response;
};

export const getUsersWithLicenseCheck = async () => {
  const store = GlobalReduxStore.getStore();
  let response;

  try {
    response = await store.dispatch(invokeAPI(SignalRHub.USER_MANAGEMENT, SignalREvent.GET_USERS_WITH_LICENSE_CHECK));
  } catch (err) {
    console.error('error on calling getUsersWithLicenseCheck API', err);
  }

  return response;
};

export const addFavoriteProtocols = async (protocolIds = []) => {
  const store = GlobalReduxStore.getStore();
  const userId = selectSessionUserId(store.getState());

  let response;

  try {
    response = await store.dispatch(
      invokeAPI(SignalRHub.PROTOCOL_MANAGEMENT, SignalREvent.ADD_FAVORITE_PROTOCOLS, userId, protocolIds),
    );
  } catch (err) {
    console.error('error on calling addFavoriteProtocols API', err);
  }

  return response;
};

export const removeFavoriteProtocols = async (protocolIds = []) => {
  const store = GlobalReduxStore.getStore();
  const userId = selectSessionUserId(store.getState());

  let response;

  try {
    response = await store.dispatch(
      invokeAPI(SignalRHub.PROTOCOL_MANAGEMENT, SignalREvent.REMOVE_FAVORITE_PROTOCOLS, userId, protocolIds),
    );
  } catch (err) {
    console.error('error on calling removeFavoriteProtocols API', err);
  }

  return response;
};

export const getFavoriteProtocols = async () => {
  const store = GlobalReduxStore.getStore();
  const userId = selectSessionUserId(store.getState());

  let response;

  try {
    response = await store.dispatch(
      invokeAPI(SignalRHub.PROTOCOL_MANAGEMENT, SignalREvent.GET_FAVORITE_PROTOCOLS, userId, false),
    );
  } catch (err) {
    console.error('error on calling getFavoriteProtocols API', err);
  }

  return response.payload;
};
